"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MultiSelectInput = _interopRequireDefault(require("./MultiSelectInput"));

var _MultiSelectedItemTag = _interopRequireDefault(require("./MultiSelectedItemTag"));

var _MultiSelectDropdown = _interopRequireDefault(require("./MultiSelectDropdown"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _PopupProvider = _interopRequireDefault(require("../Utility/PopupProvider"));

var _PopupProvider_placements = require("../Utility/PopupProvider_placements");

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Placements for PopupProvider.
var selectPlacements = {
  top: JSON.parse(JSON.stringify(_PopupProvider_placements.placementPositions.top)),
  bottom: JSON.parse(JSON.stringify(_PopupProvider_placements.placementPositions.bottom))
}; // TODO: Support for keyboard event.
// key up, key down, and enter to select/unselect.

/**
 * MultiSelect provides a way of select multiple items via a
 * drop down.  It also provide a quick filter/search string to
 * narrow down your selections.
 */

var MultiSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelect, _React$Component);

  function MultiSelect(props) {
    var _this;

    _classCallCheck(this, MultiSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelect).call(this, props));

    _this.handleWindowResize = function () {
      _this.setState({
        dropdownWidth: "".concat(_this.selectRef.current.clientWidth, "px")
      });
    };

    _this.handleSelectedItemOnClose = function (id) {
      var _this$props = _this.props,
          selectedRows = _this$props.selectedRows,
          onSelectedChange = _this$props.onSelectedChange,
          rowIdAttribute = _this$props.rowIdAttribute;
      /**
       * Remove the matched 'id' from the selectedRows list.
       */

      onSelectedChange(selectedRows.filter(function (row) {
        if (row[rowIdAttribute] !== id) {
          return row;
        }

        return null;
      }));
    };

    _this.handleOnRowSelectChange = function (selectedIds, id, added) {
      var _this$props2 = _this.props,
          clearInputValueOnRowSelected = _this$props2.clearInputValueOnRowSelected,
          rowsData = _this$props2.rowsData,
          selectedRows = _this$props2.selectedRows,
          inputProps = _this$props2.inputProps,
          rowIdAttribute = _this$props2.rowIdAttribute,
          onSelectedChange = _this$props2.onSelectedChange;
      var onChange = inputProps.onChange;
      var newSelectedRows;

      if (added) {
        var newRow = (0, _find2.default)(rowsData, function (row) {
          return row[rowIdAttribute] === id;
        });
        newSelectedRows = [].concat(_toConsumableArray(selectedRows), [newRow]);
      } else {
        newSelectedRows = selectedRows.filter(function (row) {
          return row[rowIdAttribute] !== id;
        });
      }

      onSelectedChange(newSelectedRows);

      if (clearInputValueOnRowSelected) {
        if (onChange) {
          onChange('');
          return;
        }

        _this.setState({
          inputValue: ''
        });
      }
    };

    _this.handleOnInputChange = function (event) {
      var inputProps = _this.props.inputProps;
      var onChange = inputProps.onChange;

      if (onChange) {
        onChange(event.currentTarget.value);
        return;
      }

      _this.setState({
        inputValue: event.currentTarget.value
      });
    };

    _this.handleOnInputKeyDown = function (event) {
      var _this$props3 = _this.props,
          selectedRows = _this$props3.selectedRows,
          rowIdAttribute = _this$props3.rowIdAttribute; // if the input key event is a backspace and the input value is empty
      // then delete the last selected item from the selectedIds

      if (!event.currentTarget.value && selectedRows.length && event.key === 'Backspace') {
        _this.handleSelectedItemOnClose(selectedRows.pop()[rowIdAttribute]);
      }
    };

    _this.handleInputBlur = function (event) {
      if (_this.isClickedInside) {
        /**
         * There was a mouse down event in either the MultiSelectDropdown
         * or the MutliSelectInput, so we will ignore the blur event
         * and keep the input focus.
         */
        event.currentTarget.focus();
        _this.isClickedInside = false;
        return;
      }
      /**
       * User must have been clicked outside this component to cause a blur
       * or using tab keyboard event.  Set the state to deactivate the drop down
       * and clear any input search string.
       */


      var inputProps = _this.props.inputProps;
      var onChange = inputProps.onChange;
      var inputValue = '';

      if (onChange) {
        onChange(inputValue);
      }

      _this.setState({
        active: false,
        inputValue: inputValue
      });
    };

    _this.handleMouseDown = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      } // Keep the dropdown open and search input focus.


      _this.setState({
        active: true
      });
      /**
       * Normally we are counting on handleInputBlur to clear isClickedInside
       * flag.  But for the situation where we are already focused and the user
       * clicked on the input focus again, we will get a mouse down event
       * but we will never get a blur event.
       */


      _this.isClickedInside = true;
      setTimeout(function () {
        _this.isClickedInside = false;
      }, 0);
    };

    _this.handleOnPopupAlign = function (dom) {
      if (dom.className.includes('-placement-top')) {
        _this.setState({
          dropdownPlacement: 'top'
        });

        return;
      }

      _this.setState({
        dropdownPlacement: 'bottom'
      });
    };

    _this.state = {
      // This is used to show and hide the drop down options and
      // to focus on the selection input
      active: false,
      // Current search input value to filter drop down row options.
      inputValue: '',
      // Current row id in the drop down where the mouse is hovering over.
      hoverRowId: '',
      // The width in 'px' to render the drop down.  This is set based
      // on the size of the render of MultiSelectInput
      dropdownWidth: '0',
      // See handleOnPopupAlign().  top | bottom
      dropdownPlacement: 'bottom'
    };
    _this.selectRef = _react.default.createRef();
    _this.currentInputHeight = 0; // Internal state to manage proper focus on the search input.

    _this.isClickedInside = false;
    return _this;
  }
  /**
   * @override
   */


  _createClass(MultiSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Initialize and setup a handler to size the drop down container
      // properly.
      window.addEventListener('resize', this.handleWindowResize);
      this.handleWindowResize();
      this.currentInputHeight = this.selectRef.current.clientHeight;
    }
    /**
     * @override
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Unregister resize handler.
      window.removeEventListener('resize', this.handleWindowResize);
    }
    /**
     * @override
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      // When the input height changed, the dropdown is active(open),
      // and the dropdown is positioning at the bottom
      // we want to close/re-open the drop down
      // to force PopupProvider to reposition.
      if (this.currentInputHeight !== this.selectRef.current.clientHeight && this.state.active === true && this.state.dropdownPlacement === 'bottom') {
        this.currentInputHeight = this.selectRef.current.clientHeight; // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          active: false
        }, function () {
          // According to ReactJS by the time we get here render already completed
          // with active = false (dropdown is closed).  But some how we need
          // this async to complete the first render.
          setTimeout(function () {
            return _this2.setState({
              active: true
            });
          });
        });
      }
    }
    /**
     * @override
     * @param {object} props - next Props
     * @param {object} state - previous state
     * @return {object|null} new state object or null
     */

  }, {
    key: "renderDropDownOptions",
    value: function renderDropDownOptions() {
      var _this3 = this;

      var _this$props4 = this.props,
          selectedRows = _this$props4.selectedRows,
          rowsData = _this$props4.rowsData,
          rowIdAttribute = _this$props4.rowIdAttribute,
          rowRenderer = _this$props4.rowRenderer,
          rowFilterer = _this$props4.rowFilterer,
          loading = _this$props4.loading,
          dropdownProps = _this$props4.dropdownProps;
      var inputValue = this.state.inputValue.toLowerCase();
      var selectedIds = selectedRows.map(function (row) {
        return row[rowIdAttribute];
      });

      if (!rowsData.length && !inputValue) {
        // No dropdown if there are no data and no search input value.
        return _react.default.createElement("span", null);
      }

      var filteredRows = rowsData.filter(function (row) {
        var label = row.label;

        if (inputValue) {
          if (rowFilterer) {
            return rowFilterer(row, _this3.state.inputValue);
          }

          return label.toLowerCase().includes(inputValue);
        }

        return true;
      }); // callback on mousedown event on dropdown

      var onDropdownMouseDown = function onDropdownMouseDown(e) {
        _this3.handleMouseDown(e);

        var onMouseDown = dropdownProps.onMouseDown;

        if ((0, _isFunction2.default)(onMouseDown)) {
          onMouseDown(e);
        }
      };

      var multiSelectDropdownProps = _objectSpread({
        loading: loading,
        rowsData: filteredRows,
        selectedIds: selectedIds,
        rowIdAttribute: rowIdAttribute,
        rowRenderer: rowRenderer,
        noDataMessage: _I18nManager.default.t('MultiSelect', 'no_data_message').replace('%s', "\"".concat(this.state.inputValue, "\""))
      }, dropdownProps, {
        onMouseDown: onDropdownMouseDown,
        onSelectedChange: this.handleOnRowSelectChange
      });

      return _react.default.createElement(_MultiSelectDropdown.default, multiSelectDropdownProps);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var getPopupContainer = this.props.getPopupContainer;

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement(_StackingLayout.default, {
        itemSpacing: "10px"
      }, _react.default.createElement(_PopupProvider.default, {
        popupClassName: (0, _classnames.default)("".concat(clsPrfx, "-multi-select-popup ").concat(clsPrfx)),
        popupStyle: {
          width: this.state.dropdownWidth
        },
        action: "focus",
        popup: this.renderDropDownOptions(),
        popupVisible: this.state.active,
        popupPlacement: "bottom",
        builtinPlacements: selectPlacements,
        getPopupContainer: getPopupContainer,
        onPopupAlign: this.handleOnPopupAlign
      }, this.renderMultiSelectInput()));
    }
  }, {
    key: "renderMultiSelectInput",
    value: function renderMultiSelectInput() {
      var _this4 = this;

      var _this$props5 = this.props,
          rowIdAttribute = _this$props5.rowIdAttribute,
          selectedRows = _this$props5.selectedRows,
          rowsData = _this$props5.rowsData,
          disabled = _this$props5.disabled,
          inputProps = _this$props5.inputProps;
      var selectedItems = [];
      var rowsMapping = {};
      rowsData.forEach(function (rowData) {
        rowsMapping[rowData.id] = rowData;
      });
      selectedRows.forEach(function (row) {
        var rowLabel = row.label;
        var id = row[rowIdAttribute];
        selectedItems.push(_react.default.createElement(_MultiSelectedItemTag.default, {
          key: id,
          id: id,
          onClose: _this4.handleSelectedItemOnClose,
          disabled: disabled
        }, rowLabel));
      });
      var wrapperProps = {
        'data-dropdown-placement': this.state.dropdownPlacement
      };

      var multiSelectInputProps = _objectSpread({}, inputProps, {
        value: this.state.inputValue,
        onChange: this.handleOnInputChange,
        onKeyDown: this.handleOnInputKeyDown,
        onBlur: this.handleInputBlur,
        disabled: disabled,
        focus: this.state.active
      });

      return _react.default.createElement(_MultiSelectInput.default, _extends({}, multiSelectInputProps, {
        wrapperProps: wrapperProps
      }), selectedItems);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      /* eslint-disable no-unused-vars */
      var _this$props6 = this.props,
          className = _this$props6.className,
          rowIdAttribute = _this$props6.rowIdAttribute,
          selectedRows = _this$props6.selectedRows,
          rowsData = _this$props6.rowsData,
          disabled = _this$props6.disabled,
          label = _this$props6.label,
          onSelectedChange = _this$props6.onSelectedChange,
          onInputValueChange = _this$props6.onInputValueChange,
          rowRenderer = _this$props6.rowRenderer,
          rowFilterer = _this$props6.rowFilterer,
          getPopupContainer = _this$props6.getPopupContainer,
          clearInputValueOnRowSelected = _this$props6.clearInputValueOnRowSelected,
          inputProps = _this$props6.inputProps,
          loading = _this$props6.loading,
          dropdownProps = _this$props6.dropdownProps,
          onMouseDown = _this$props6.onMouseDown,
          props = _objectWithoutProperties(_this$props6, ["className", "rowIdAttribute", "selectedRows", "rowsData", "disabled", "label", "onSelectedChange", "onInputValueChange", "rowRenderer", "rowFilterer", "getPopupContainer", "clearInputValueOnRowSelected", "inputProps", "loading", "dropdownProps", "onMouseDown"]);
      /* eslint-enable */


      var clsPrfx = _ThemeManager.default.getVar('classPrefix'); // callback on mousedown event on select input


      var onInputMouseDown = function onInputMouseDown(e) {
        _this5.handleMouseDown(e);

        if ((0, _isFunction2.default)(onMouseDown)) {
          onMouseDown(e);
        }
      };

      return _react.default.createElement("div", _extends({
        ref: this.selectRef
      }, props, {
        className: (0, _classnames.default)(className, "".concat(clsPrfx, " ").concat(clsPrfx, "-multi-select")),
        onMouseDown: onInputMouseDown
      }), this.renderInput());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var inputProps = props.inputProps;

      if (!(0, _isNil2.default)(inputProps.value)) {
        return _objectSpread({}, state, {
          inputValue: inputProps.value
        });
      }

      return null;
    }
    /**
     * Handler to set drop down width to match MultiSelectInput component.
     */

  }]);

  return MultiSelect;
}(_react.default.Component);

exports.default = MultiSelect;
MultiSelect.MultiSelectedItemTag = _MultiSelectedItemTag.default;
MultiSelect.MultiSelectInput = _MultiSelectInput.default;
MultiSelect.MultiSelectDropdown = _MultiSelectDropdown.default;
MultiSelect.defaultProps = {
  rowIdAttribute: 'id',
  selectedRows: [],
  rowsData: [],
  disabled: false,
  clearInputValueOnRowSelected: true,
  inputProps: {},
  dropdownProps: {},
  loading: false
};
MultiSelect.propTypes = {
  /**
   * This is short text label for the selector.
   */
  label: _propTypes.default.string,

  /**
   * Array of row object that are currently being selected.
   */
  selectedRows: _propTypes.default.array.isRequired,

  /**
   * Disable component input.
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function to handle the change(added/removed selection)
   * of selectedIds list.<br>
   * onSelectedChange(selectedRows)<br>
   * @param {array} selectedRows: List of row that are currently being selected.
   */
  onSelectedChange: _propTypes.default.func.isRequired,

  /**
   * The key attribute in a row item from rowsData[] to use as
   * a unique identifier.
   */
  rowIdAttribute: _propTypes.default.string,

  /**
   * By default the drop down options render each row option with
   * with a checkbox followed by the row.label.
   * This callback allows you to customize your rendering of row data.<br>
   * rowRenderer(rowData, isSelected, isHover)<br>
   * @param {object} rowData: This is the data for the row.
   * @param {boolean} isSelected: true if is marked as selected, false otherwise.
   * @param {boolean} isHover: true if the mouse cursor is hovering on the row.
   * @return {ReactNode} - The function should return a React node.
   */
  rowRenderer: _propTypes.default.func,

  /**
   * By default this component show only drop down options that matched
   * the input field value against the rowsData[].label.
   * This callback allows you to customize the handling of this behavior.
   * rowFilterer(rowData, inputValue)<br>
   * @param {object} rowData: This is the data for the row option.<br>
   * @param {string} inputValue: The current filter input value.<br>
   * Note: the inputValue passing to the application is case sensitive.<br>
   * @return {boolean} - This function should return true to indicate that
   * the row item should be included in the drop down options list else false.
   */
  rowFilterer: _propTypes.default.func,

  /**
   * Array of rows.  Each row is a select option.
   */
  rowsData: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Unique string/num identifier for this item.
     * Unless props.rowIdAttribute defined a different string, 'id' is required.
     */
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

    /**
     * When this item is selected this is the label used to display on
     * the top level selected items input.
     * This is also used to display in the drop down option.  If you need
     * to customize what to display for each row see pros.rowRenderer
     */
    label: _propTypes.default.string.isRequired
  })),

  /**
   * This can be any valid input dom attributes.
   */
  inputProps: _propTypes.default.object,

  /**
   * Props to pass to dropdown
   */
  dropdownProps: _propTypes.default.object,

  /**
   * By default the drop down dom is created in the document.body and the handling
   * of scroll changes are done at the same level.   . e.g. `() => document.querySelector('.right-panel')`
   */
  getPopupContainer: _propTypes.default.func,

  /**
   * By default after a row is selected the input value will be cleared.
   */
  clearInputValueOnRowSelected: _propTypes.default.bool,

  /**
   * To indicate that rowsData is being loaded.
   */
  loading: _propTypes.default.bool
};